import {
  EmbeddedViewRef,
  EnvironmentInjector,
  Injectable,
  createComponent,
} from '@angular/core';
import { ToastComponent } from '../components/toast.component';
import { ToastType } from '../toast-types';
import * as bootstrap from 'bootstrap';

@Injectable({ providedIn: 'root' })
export class ToastService {
  constructor(private environmentInjector: EnvironmentInjector) {}

  public success(message?: string, title?: string) {
    this.show(ToastType.Success, message, title);
  }

  public warning(message?: string, title?: string) {
    this.show(ToastType.Warning, message, title);
  }

  public error(message?: string, title?: string) {
    this.show(ToastType.Error, message, title);
  }

  public info(message?: string, title?: string) {
    this.show(ToastType.Info, message, title);
  }

  private show(type: ToastType, message?: string, title?: string) {
    //create a component reference
    const componentRef = createComponent(ToastComponent, {
      environmentInjector: this.environmentInjector,
    });

    componentRef.instance.type = type;
    componentRef.instance.message = message;
    componentRef.instance.title = title;
    componentRef.changeDetectorRef.detectChanges();

    // get DOM element from component
    const domElem = (componentRef.hostView as EmbeddedViewRef<unknown>)
      .rootNodes[0] as HTMLElement;

    const toastContainer = this.addContainer();

    toastContainer.append(domElem);

    const toast = new bootstrap.Toast(domElem.querySelector('.toast'));
    toast.show();

    componentRef.instance.self = toast;

    const removeContainerFn = this.removeContainer;
    domElem.addEventListener('hidden.bs.toast', function hiddenEvent() {
      domElem.removeEventListener('hidden.bs.toast', hiddenEvent);
      domElem.remove();
      removeContainerFn();
      componentRef.destroy();
    });

    return componentRef;
  }

  private addContainer() {
    let toastContainer = document.querySelector('.toast-container');
    if (toastContainer) {
      return toastContainer;
    }

    toastContainer = document.createElement('div');
    toastContainer.className = 'toast-container position-fixed top-0 end-0 p-3';
    (toastContainer as HTMLElement).style.zIndex = '999999';

    document.body.append(toastContainer);

    return toastContainer;
  }

  private removeContainer() {
    const toastContainer = document.querySelector('.toast-container');

    if (toastContainer.hasChildNodes()) {
      return;
    }

    toastContainer.remove();
  }
}
